import { EditOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

import { useLanguage, usePermissionFlags } from '../../../hooks';
import { openFrontendRouteInNewTab, paths } from '../../../utils/navigation';
import { ListTabs } from '../searchDataListModal';

interface SearchDataListModalActionsProps {
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonDisabled: boolean;
  activeTab: ListTabs | null;
}

interface StyleProps {
  withoutLink: boolean;
}

const customStylesHandler = ({ withoutLink }: StyleProps) => ({
  modalActions: {
    display: 'flex',
    justifyContent: withoutLink ? 'space-between' : 'flex-end',
    width: '100%',
    gap: '16px',
  },
  btnContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
  },
  confirmBtn: {
    backgroundColor: '#3E8FFA',
    color: '#fff',
    width: '122px',
    fontSize: '15px',
    '&:hover': {
      backgroundColor: '#3E8FFA',
      color: '#fff',
      opacity: 0.8,
    },
    '&:disabled': {
      color: '#fff',
      opacity: 0.5,
    },
  },
  cancelBtn: {
    width: '122px',
    fontSize: '15px',
  },
  editListLink: {
    fontSize: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  editListIcon: {
    fontSize: '14px',
    marginRight: '4px',
  },
});

export const SearchDataListModalActions = ({
  onClose,
  onConfirm,
  confirmButtonDisabled,
  activeTab,
}: SearchDataListModalActionsProps) => {
  const lang = useLanguage();
  const { checkPermission } = usePermissionFlags();
  const metadataPermission = checkPermission('metadata');
  const customStyles = customStylesHandler({ withoutLink: metadataPermission ? false : true });

  const editLinkPath =
    activeTab === ListTabs.Locations
      ? paths.locations.index
      : activeTab === ListTabs.Assets
        ? paths.assets.types
        : paths.lists.index;
  const editLinkLabel =
    activeTab === ListTabs.Locations
      ? lang.form_builder.editLocations
      : activeTab === ListTabs.Assets
        ? lang.form_builder.editAssets
        : lang.form_builder.editLists;

  return (
    <div style={customStyles.modalActions}>
      {metadataPermission && (
        <Button
          sx={customStyles.editListLink}
          onClick={() => openFrontendRouteInNewTab(editLinkPath)}
          data-testid='edit-list-link'
        >
          <EditOutlined sx={customStyles.editListIcon} />
          {editLinkLabel}
        </Button>
      )}
      <div style={customStyles.btnContainer}>
        <Button
          onClick={onClose}
          variant='outlined'
          color='secondary'
          sx={customStyles.cancelBtn}
        >
          {lang.form_builder.cancel}
        </Button>
        <Button
          onClick={() => onConfirm()}
          autoFocus
          sx={customStyles.confirmBtn}
          disabled={confirmButtonDisabled}
        >
          {lang.form_builder.use}
        </Button>
      </div>
    </div>
  );
};
